import { useState } from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import VuiInput from "components/VuiInput";
import { sendRequestWithdrawal } from "../../../../../services/transactions/transactions.service";
import { useSnackbar } from "../../../../../context/SnackbarContext";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { sharingInformationService } from "../sharingInfo.service";
import "./loader.css";

export const Withdrawal = ({ ibInfo, handleClose, txMethod }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { showSnackbar } = useSnackbar();
  const [amount, setAmount] = useState(0);
  const [successOperation, setSuccessOperation] = useState(false);

  const requestWithdrawal = async () => {
    if (amount <= 0 || amount < txMethod.configuration.amountMin) {
      showSnackbar({ message: "Monto no válido", type: "error", duration: 2000 });
      return;
    }

    setIsLoading(true);
    const { success, kindMessage } = await sendRequestWithdrawal({
      requestData: {
        address: ibInfo.walletId,
        amount,
        currencyId: txMethod.currencies[0].id || 1,
      },
    });

    if (success) {
      setSuccessOperation(true);
      setIsLoading(false);
      sharingInformationService.setSubject(success);
    } else {
      setIsLoading(false);
      showSnackbar({ message: kindMessage, type: "error", duration: 2000 });
    }
  };

  if (isLoading) {
    return (
      <Grid
        container
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          width: "100%",
          borderRadius: "10px",
        }}
        gap={3}
      >
        <Grid
          item
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <span className="loader"></span>
        </Grid>
      </Grid>
    );
  }

  if (successOperation && !isLoading) {
    return (
      <Grid
        container
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          width: "100%",
          borderRadius: "10px",
          marginTop: "-20px",
        }}
      >
        <Grid
          item
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
          gap={2}
        >
          <CheckCircleOutlineIcon sx={{ color: "#00C853", fontSize: "80px !important" }} />
          <Box>
            <Typography
              sx={{
                fontSize: "20px",
                fontWeight: "700",
                lineHeight: "24px",
                color: "#FFFFFF",
                textWrap: "nowrap",
                overflow: "hidden",
                whiteSpace: "nowrap",
              }}
            >
              Solicitud de retiro enviada
            </Typography>
          </Box>
          <Box>
            <Typography
              sx={{
                fontSize: "16px",
                lineHeight: "24px",
                color: "#FFFFFF",
                textAlign: "center",
              }}
            >
              Su retiro está siendo procesado. Nos pondremos en contacto con usted en caso de que
              haya algún problema.
            </Typography>
          </Box>
          <Box>
            <Button
              variant="contained"
              sx={{
                height: "50px",
                width: "280px",
                borderRadius: "10px",
                fontWeight: "700",
                fontSize: "16px",
                color: "white !important",
              }}
              onClick={handleClose}
            >
              Regresar
            </Button>
          </Box>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid
      container
      sx={{
        padding: "15px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100%",
        width: "100%",
        borderRadius: "10px",
      }}
      gap={3}
    >
      <Grid item sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <Grid item sx={{ display: "flex", alignItems: "center", gap: "20px" }}>
          <Typography
            sx={({ breakpoints }) => ({
              fontSize: "24px",
              fontWeight: "700",
              lineHeight: "24px",
              color: "#FFFFFF",
              [breakpoints.down("md")]: {
                fontSize: "16px",
              },
            })}
          >
            <span>Tienes $ {ibInfo.ibAccumulatedBenefit}</span>
          </Typography>
        </Grid>

        <Grid item sx={{ display: "flex", alignItems: "center", gap: "20px" }}>
          <Typography
            sx={({ breakpoints }) => ({
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "24px",
              color: "#FFFFFF",
              [breakpoints.down("md")]: {
                fontSize: "16px",
              },
            })}
          >
            <span>* Monto mínimo: {txMethod.configuration.amountMin}</span>
          </Typography>
          <Typography
            sx={({ breakpoints }) => ({
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "24px",
              color: "#FFFFFF",
              [breakpoints.down("md")]: {
                fontSize: "16px",
              },
            })}
          >
            <span>* Monto máximo: {txMethod.configuration.amountMax || "Ninguno"}</span>
          </Typography>

          <Typography
            sx={({ breakpoints }) => ({
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "24px",
              color: "#FFFFFF",
              [breakpoints.down("md")]: {
                fontSize: "16px",
              },
            })}
          >
            <span>* {txMethod.currencies[0].token} {txMethod.currencies[0].network}</span>
          </Typography>
        </Grid>

        <Grid item>
          <Box sx={{ display: "flex", alignItems: "center", gap: "20px", marginTop: "20px" }}>
            <Box sx={{ width: "fit" }}>
              <Typography
                sx={{
                  fontSize: "20px",
                  lineHeight: "24px",
                  color: "#FFFFFF",
                  textWrap: "nowrap",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                }}
              >
                Wallet:
              </Typography>
            </Box>
            <Box sx={{ width: "100%" }}>
              <VuiInput value={ibInfo.walletId} readOnly={true} />
            </Box>
          </Box>
        </Grid>

        <Grid item>
          <Box sx={{ display: "flex", alignItems: "center", gap: "20px" }}>
            <Box sx={{ width: "fit" }}>
              <Typography
                sx={{
                  fontSize: "20px",
                  lineHeight: "24px",
                  color: "#FFFFFF",
                  textWrap: "nowrap",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                }}
              >
                Monto:
              </Typography>
            </Box>
            <Box sx={{ width: "100%" }}>
              <VuiInput type="number" value={amount} onChange={(e) => setAmount(e.target.value)} />
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Grid item sx={{ display: "flex", alignItems: "center", gap: "20px", width: "100%" }}>
        <Button
          variant="contained"
          sx={{
            width: "100%",
            height: "50px",
            borderRadius: "10px",
            backgroundColor: "#FFFFFF",
            color: "#011A3D",
            fontWeight: "700",
            fontSize: "16px",
            "&:hover": {
              backgroundColor: "#FFFFFF !important",
              color: "black !important",
            },
          }}
          onClick={requestWithdrawal}
        >
          Solicitar
        </Button>

        <Button
          variant="contained"
          sx={{
            width: "50%",
            height: "50px",
            borderRadius: "10px",
            backgroundColor: "#454b52",
            color: "white !important",
            fontWeight: "700",
            fontSize: "16px",
            "&:hover": {
              backgroundColor: "#454b52 !important",
              color: "white !important",
            },
          }}
          color="error"
          onClick={handleClose}
        >
          Cancelar
        </Button>
      </Grid>
    </Grid>
  );
};
